import { Native } from '.';
import { defineActions } from '../utils';
import { action } from '@play-co/replicant';
import { initializeFirstAppInstall } from './native.modifiers';

export const nativeActions = defineActions<Native>()({
  /**
   * Update last launch date for IOS devices
   */
  updateAppleLastLaunched: action((state, _, api) => {
    // Is this first native app install for this user?
    if (state.native.appleLastLaunched === 0) {
      initializeFirstAppInstall(state);
    }

    state.native.appleLastLaunched = api.date.now();
  }),

  /**
   * Update last launch date for ANDROID devices
   */
  updateGoogleLastLaunched: action((state, _, api) => {
    // Is this first native app install for this user?
    if (state.native.googleLastLaunched === 0) {
      initializeFirstAppInstall(state);
    }

    state.native.googleLastLaunched = api.date.now();
  }),

  /**
   * Native app install reward promo was shown for this user
   */
  installRewardWasShown: action((state, _, api) => {
    if (state.native.appInstallRewardStatus === 'idle') {
      state.native.appInstallRewardStatus = 'saw_promo';
    }
  }),

  /**
   * Claim reward for installation native app
   */
  claimInstallReward: action((state, _, api) => {
    const reward = Native.ruleset.appInstallReward;
    const { Inventory } = Native.$DEPENDENCIES;

    // If reward state is in received give reward
    if (state.native.appInstallRewardStatus === 'received') {
      // Give reward
      Inventory.modifiers(state).addFreeGems(reward.gems);
      Inventory.modifiers(state).addPoints(reward.coins);

      // Switch to claimed state
      state.native.appInstallRewardStatus = 'claimed';
    }
  }),
});
